import { Heart, LogOut, Package, Settings, User } from 'lucide-react';
import { NavLink, Outlet } from 'react-router-dom';
import PageHeader from './../Common/PageHeader';
import './UserAccount.css';

const UserAccount = () => {
  return (
    <>
      <PageHeader title="My Profile" />
      <section className="container-fluid">
        <div className="row">
          {/* Sidebar */}
          <div className="col-12 mb-3">
            <nav className="profile_sidebar shadow-sm rounded py-3 px-2 w-100">
              <ul className="nav w-100 d-flex align-items-center justify-content-between gap-2">
                <li className="flex-fill text-center">
                  <NavLink
                    to="/account/profile"
                    className="nav-link d-flex align-items-center justify-content-center"
                  >
                    <User className="profile_icon me-2" size={18} />
                    <span>Dashboard</span>
                  </NavLink>
                </li>

                <li className="flex-fill text-center">
                  <NavLink
                    to="/account/orders-history"
                    className="nav-link d-flex align-items-center justify-content-center"
                  >
                    <Package className="profile_icon me-2" size={18} />
                    <span>Orders</span>
                  </NavLink>
                </li>

                <li className="flex-fill text-center">
                  <NavLink
                    to="/account/my-wishlist"
                    className="nav-link d-flex align-items-center justify-content-center"
                  >
                    <Heart className="profile_icon me-2" size={18} />
                    <span>Wishlist</span>
                  </NavLink>
                </li>

                <li className="flex-fill text-center">
                  <NavLink
                    to="/account/profile-setting"
                    className="nav-link d-flex align-items-center justify-content-center"
                  >
                    <Settings className="profile_icon me-2" size={18} />
                    <span>Settings</span>
                  </NavLink>
                </li>

                <li className="flex-fill text-center">
                  <NavLink
                    to="/account/logout"
                    className="nav-link logout-link d-flex align-items-center justify-content-center "
                  >
                    <LogOut size={18} className="me-2" />
                    <span>Logout</span>
                  </NavLink>
                </li>
              </ul>
            </nav>
          </div>

          {/* Main Content */}
          <div className="col-12">
            <div className="profile_details">
              <Outlet />
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default UserAccount;
